// extracted by mini-css-extract-plugin
export default {"addModalContent":"AddChildModal_addModalContent__boeDd","addModalContainer":"AddChildModal_addModalContainer__-iWMO","addChildModalTitle":"AddChildModal_addChildModalTitle__jOuqK"};